
import { useGestures } from "@/hooks/useGestures";

interface UseChatGesturesProps {
  onClose: () => void;
  isOpen: boolean;
  isMobile: boolean;
  setSwipeIndicator: (indicator: 'left' | 'right' | null) => void;
}

export function useChatGestures({ onClose, isOpen, isMobile, setSwipeIndicator }: UseChatGesturesProps) {
  const {
    ref,
    gestureState
  } = useGestures({
    swipe: {
      threshold: 50,
      // Distance alone decides — a slow deliberate swipe should still close
      // the drawer, not just fast flicks (default velocity gate is 0.3px/ms).
      velocityThreshold: 0,
      // Mobile only — on desktop a fast mouse drag (e.g. text selection)
      // must not be interpreted as a swipe-to-close.
      onSwipe: isMobile
        ? ({ direction }) => {
            if (direction === 'right') {
              onClose();
              setSwipeIndicator('right');
              setTimeout(() => setSwipeIndicator(null), 500);
            }

            if (direction === 'left' && !isOpen) {
              setSwipeIndicator('left');
              setTimeout(() => setSwipeIndicator(null), 500);
            }
          }
        : undefined,
    },
  });

  return {
    swipeHandlers: {
      ref,
      gestureState
    },
  };
}
